export const CONTACT_US_LINK: any = {
  ar: 'https://www.sanlamallianz.ma/ar/reclamation',
  fr: 'https://www.sanlamallianz.ma/fr/reclamation',
};

export const RECLAMATION_LINK: any = {
  ar: 'https://www.sanlamallianz.ma/ar/reclamation',
  fr: 'https://www.sanlamallianz.ma/fr/reclamation',
};

export const PREVENTION_AUTO_LINK: any = {
  ar:
    'https://www.sanlamallianz.ma/sites/default/files/guide_de_prevention_auto.pdf',
  fr:
    'https://www.sanlamallianz.ma/sites/default/files/guide_de_prevention_auto.pdf',
};

export const PREMIUM_AUTO_LINK: any = {
  ar: 'https://sanlamallianz.ma/ar/offres/auto-moto/assurauto-premium',
  fr: 'https://sanlamallianz.ma/fr/offres/auto-moto/assurauto-premium',
};

export const ASSUR_HABITATION_LINK: any = {
  ar: 'https://sanlamallianz.ma/ar/offres/habitation/assurance-habitation',
  fr: 'https://sanlamallianz.ma/fr/offres/habitation/assurance-habitation',
};

export const PREVENTION_MRH_LINK: any = {
  ar: 'https://www.sanlamallianz.ma/ar/prevention-habitation',
  fr: 'https://www.sanlamallianz.ma/prevention-habitation',
};

export const PRODUCT_ASSUR_AUTO_RABEH_LINK: any = {
  ar: 'https://sanlamallianz.ma/ar/offres/auto-moto/assurauto-rabe7/',
  fr: 'https://sanlamallianz.ma/fr/offres/auto-moto/assurauto-rabe7',
};

export const PRODUCT_WAQET_OU_ZMANE_LINK: any = {
  ar:
    'https://sanlamallianz.ma/ar/offres/sante-prevoyance/assurance-deces-damane',
  fr:
    'https://sanlamallianz.ma/fr/offres/sante-prevoyance/assurance-deces-damane',
};

export const YOUTUBE_LINK: string =
  'https://www.youtube.com/user/SahamAssuranceMaroc';
export const FACEBOOK_LINK: string =
  'https://web.facebook.com/sahamassurancemaroc/?_rdc=1&_rdr';

export const MRH_QUOTE_LINK: any = {
  ar: 'https://souscription-en-ligne.sanlamallianz.ma/habitation-simulation',
  fr: 'https://souscription-en-ligne.sanlamallianz.ma/habitation-simulation',
};

export const EPARGN_PRODUCT_LINK: any = {
  ar: 'https://sanlamallianz.ma/ar/produit/epargne',
  fr: ' https://sanlamallianz.ma/produit/epargne',
};

export const OFFER_ADVICE_RENEW_LINK: any = {
  ar:
    'https://souscription-en-ligne.sanlamallianz.ma/assurance-auto-renouvellement',
  fr:
    'https://souscription-en-ligne.sanlamallianz.ma/assurance-auto-renouvellement',
};

export const OFFER_ADVICE_NEW_BUSINESS_LINK: any = {
  ar:
    'https://souscription-en-ligne.sanlamallianz.ma/assurance-auto-simulation',
  fr:
    'https://souscription-en-ligne.sanlamallianz.ma/assurance-auto-simulation',
};

export const OFFER_ADVICE_MRH_LINK: any = {
  ar: 'https://souscription-en-ligne.sanlamallianz.ma/habitation-simulation',
  fr: 'https://souscription-en-ligne.sanlamallianz.ma/habitation-simulation',
};

export const OFFER_ADVICE_ADE_LINK: any = {
  ar:
    'https://souscription-en-ligne.sanlamallianz.ma/assurance-pret-simulation',
  fr:
    'https://souscription-en-ligne.sanlamallianz.ma/assurance-pret-simulation',
};
